import { z } from 'zod';

export const InputSchema = z.object({
    displayNetDepositLimitsPopUp: z.boolean(),
});

export type ChangeDisplayNetDepositLimitsPopUpInputType = z.infer<typeof InputSchema>;
